var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 1.625C2.625 1.16016 3.00781 0.75 3.5 0.75C3.96484 0.75 4.375 1.16016 4.375 1.625V2.5H7.875V1.625C7.875 1.16016 8.25781 0.75 8.75 0.75C9.21484 0.75 9.625 1.16016 9.625 1.625V2.5H10.9375C11.6484 2.5 12.25 3.10156 12.25 3.8125V5.125H0V3.8125C0 3.10156 0.574219 2.5 1.3125 2.5H2.625V1.625ZM12.25 13.4375C12.25 14.1758 11.6484 14.75 10.9375 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V6H12.25V13.4375ZM3.28125 9.5H8.96875C9.32422 9.5 9.625 9.22656 9.625 8.84375C9.625 8.48828 9.32422 8.1875 8.96875 8.1875H3.28125C2.89844 8.1875 2.625 8.48828 2.625 8.84375C2.625 9.22656 2.89844 9.5 3.28125 9.5ZM3.28125 10.8125C2.89844 10.8125 2.625 11.1133 2.625 11.4688C2.625 11.8516 2.89844 12.125 3.28125 12.125H6.34375C6.69922 12.125 7 11.8516 7 11.4688C7 11.1133 6.69922 10.8125 6.34375 10.8125H3.28125Z",
    fill: "#171923"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0df2cc3b0b4820b85b55d8effc88ea99.svg";
export { ForwardRef as ReactComponent };